/**
 * Available user roles in the application.
 * Used for route access control and role-based UI rendering.
 */
export const USER_ROLES = {
  STUDENT: "student",
  TEACHER: "teacher",
  TEAMLEADER: "teamleader",
  ORGANIZER: "organizer",
  MANAGER: "manager",
  WEBMASTER: "webmaster",
  DECAAN: "decaan",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

/**
 * Common role groups for route access control.
 */
export const TEACHER_ROLES = [
  USER_ROLES.TEACHER,
  USER_ROLES.TEAMLEADER,
  USER_ROLES.ORGANIZER,
  USER_ROLES.DECAAN,
  USER_ROLES.MANAGER,
  USER_ROLES.WEBMASTER,
] as const;

export const STAFF_ROLES = TEACHER_ROLES;

export const MANAGER_ROLES = [
  USER_ROLES.WEBMASTER,
  USER_ROLES.MANAGER,
  USER_ROLES.ORGANIZER,
] as const;

/**
 * Roles that may open a meeting from the school-wide meeting overview
 * (/overview/all-meetings). A teamleader reaches that overview and gets to read
 * the meetings behind it; managing them stays with MANAGER_ROLES.
 */
export const MEETING_OVERVIEW_ROLES = [
  ...MANAGER_ROLES,
  USER_ROLES.TEAMLEADER,
] as const;

/**
 * Roles that reach the /overview section. The "Organisator portfolio" (decaan)
 * comes on top of MEETING_OVERVIEW_ROLES: they only get the portfolio tab, but
 * they do need the section itself.
 */
export const OVERVIEW_ROLES = [
  ...MEETING_OVERVIEW_ROLES,
  USER_ROLES.DECAAN,
] as const;
